import { render, staticRenderFns } from "./TrainingRegister.vue?vue&type=template&id=2ca496df"
import script from "./TrainingRegister.vue?vue&type=script&lang=js"
export * from "./TrainingRegister.vue?vue&type=script&lang=js"
import style0 from "./TrainingRegister.vue?vue&type=style&index=0&id=2ca496df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports